import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CertificationsTab } from '../../../-components/CertificationsTab';
import { adminCertificationsQueryOptions } from '../../../-hooks/useAdminCertifications';

export const Route = createFileRoute(
  '/management/certifications/(pages)/(list)/active/',
)({
  // Off the URL rather than a fixed first page, so a deep link with a sort or
  // filter prefetches the rows it will actually show.
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient
      .ensureQueryData(
        adminCertificationsQueryOptions({ ...deps, isArchived: false }),
      )
      // A failed prefetch must not blank the page — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CertificationsPage,
});

function CertificationsPage() {
  return <CertificationsTab isArchived={false} />;
}
